<template>
  <div class="card">
    <div class="card-header">
      <h5>Bonding Reports</h5>
    </div>
    <div class="card-body">
      <div class="row">
        <div class="col-md-12">
          <h6>Departure Date Range</h6>
        </div>
      </div>
      <div class="row mt-2">
        <div class="col-md-6">
          <dateTimePicker
            no-label
            label="From Date"
            id="departureDateRangeStart"
            format="YYYY-MM-DD"
            formatted="YYYY-MM-DD"
            v-model="bonding.departureDateRangeStart"
            button-color="#ec391e"
            color="#ec391e"
            :only-date="true"
            style="border: 1px solid #DFE5F9"
          />
          <small class="text-danger" v-if="bondingError.departure_start">{{ bondingError.departure_start }}</small>
        </div>
        <div class="col-md-6">
          <dateTimePicker
            no-label
            label="To Date"
            id="departureDateRangeEnd"
            format="YYYY-MM-DD"
            formatted="YYYY-MM-DD"
            v-model="bonding.departureDateRangeEnd"
            button-color="#ec391e"
            color="#ec391e"
            :only-date="true"
            :min-date="bonding.departureDateRangeStart"
            style="border: 1px solid #DFE5F9"
          />
          <small class="text-danger" v-if="bondingError.departure_end">{{ bondingError.departure_end }}</small>
        </div>
      </div>
      <div class="row mt-3">
        <div class="col-md-12">
          <div class="row">
            <div class="col-md-12">
              <h6>Booking Date Range</h6>
            </div>
          </div>
          <div class="row mt-2">
            <div class="col-md-6">
              <dateTimePicker
                no-label
                label="From Date"
                id="bookingDateRangeStart"
                format="YYYY-MM-DD"
                formatted="YYYY-MM-DD"
                v-model="bonding.bookingDateRangeStart"
                button-color="#ec391e"
                color="#ec391e"
                :only-date="true"
                style="border: 1px solid #DFE5F9"
              />
              <small class="text-danger" v-if="bondingError.booking_start">{{ bondingError.booking_start }}</small>
            </div>
            <div class="col-md-6">
              <dateTimePicker
                no-label
                label="To Date"
                id="bookingDateRangeEnd"
                format="YYYY-MM-DD"
                formatted="YYYY-MM-DD"
                v-model="bonding.bookingDateRangeEnd"
                button-color="#ec391e"
                color="#ec391e"
                :only-date="true"
                :min-date="bonding.bookingDateRangeStart"
                style="border: 1px solid #DFE5F9"
              />
              <small class="text-danger" v-if="bondingError.booking_end">{{ bondingError.booking_end }}</small>
            </div>
          </div>
        </div>
      </div>
      <div class="row mt-3">
        <div class="col-md-6">
          <label for="" class="form-label">Bonding Type</label>
          <v-select
            :options="bondingOptions"
            label="name"
            class="m-0"
            id="bonding_type"
            index="id"
            v-model="bonding.type"
          />
          <small class="text-danger" v-if="bondingError.bonding_type">{{ bondingError.bonding_type }}</small>
        </div>
      </div>
    </div>
    <div class="card-footer align-items-right">
      <button type="submit" class="button" v-on:click="getBondingReport"> Generate reort </button>
    </div>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  name: "BondingReportFields",
  props:{
    reportVersion: {
      type: String,
      default: 'v1',
      required: true,
      validator: (value) => {
        return ['v1', 'v2'].includes(value);
      }
    },
  },
  data() {
    return {
      bonding: {},
      bondingError:{
        bonding_type:null,
        departure_start:null,
        departure_end:null,
        booking_start:null,
        booking_end:null,
      },
      bondingOptions: [],
      bondingreport: {},
      errors: null,
      reportUnavailable: null,
      generatingReport: false,
    };
  },
    methods:{
    getBondingTypes()
    {
      axios.get(this.$api + 'bonding-types',
      {
        headers:{
          'Accept': 'application/json',
          'Authorization': localStorage.getItem('token')
        }
      })
      .then((response) => {
        this.bondingOptions = response.data.data
      });
    },
    getBondingReport()
    {
      let This = this
      this.validateFields()
          .then((response) => {
            if (response) {
              this.$store.dispatch('setLoadStatus')
              const request = {
                departureDateRangeStart: this.bonding.departureDateRangeStart,
                departureDateRangeEnd: this.bonding.departureDateRangeEnd,
                bookingDateRangeStart: this.bonding.bookingDateRangeStart,
                bookingDateRangeEnd: this.bonding.bookingDateRangeEnd,
                bonding_type: this.bonding.type
              }

              let url = (this.reportVersion == 'v2') ? this.$api + 'reports/v2/generate-bonding-report' : this.$api + 'reports/bondingreport';
              
              fetch(url, {
                method: 'POST',
                body: JSON.stringify(request),
                headers:{
                  'Content-Type': 'application/json',
                  'Accept': 'application/json',
                  'Authorization': localStorage.getItem('token')
                }
              })
              .then((res) => {
                if(res.status === 200) {
                  this.$store.dispatch('setLoadStatus')
                  res.blob().then(response => {
                    const _url = window.URL.createObjectURL(response)
                    const link = document.createElement('a')
                    link.href = _url
                    link.setAttribute('download', 'Bonding-Report.xlsx')
                    document.body.appendChild(link)
                    link.click();
                  })
                } else {
                  this.$store.dispatch('setLoadStatus')
                  Promise.race([res.json()])
                  .then(response => {
                    if(response.message) {
                      this.$notify({
                        type: 'error',
                        title: response.message
                      });
                    } else {
                      this.$notify({
                        type: 'error',
                        title: response.error
                      });
                    }
                  })
                }
              })
            }
          })

    },
    validateFields(){
      let This = this
      return new Promise((resolve, reject) => {

        let errorCount = 0;

        // Departure Dates validation
        if(This.bonding.departureDateRangeStart && !This.bonding.departureDateRangeEnd) {
          This.bondingError.departure_end = "Please select a valid departure to date"
          errorCount +=1
        }else if(This.bonding.departureDateRangeEnd && !This.bonding.departureDateRangeStart){
          This.bondingError.departure_start = "Please select departure from date"
          errorCount +=1
        }else{
          This.bondingError.departure_end = null
          This.bondingError.departure_start = null
        }

        // Booking Dates validation 
        if(This.bonding.bookingDateRangeStart && !This.bonding.bookingDateRangeEnd) {
          This.bondingError.booking_end = "Please select a valid booking to date"
          errorCount +=1
        }else if(This.bonding.bookingDateRangeEnd && !This.bonding.bookingDateRangeStart){
          This.bondingError.booking_start = "Please select a valid booking from date"
          errorCount +=1
        }else{
          This.bondingError.booking_end = null
          This.bondingError.booking_start = null
        }
        
        // Check for Departure date and Booking date
        if ( !This.bonding.bookingDateRangeStart && !This.bonding.departureDateRangeStart) 
        {
          This.bondingError.booking_start = "Please select booking date or departure date"
          This.bondingError.departure_start = "Please select departue date or booking date"

          errorCount +=1
        }else{
          This.bondingError.booking_start = null
          This.bondingError.departure_start = null
        }

        if (!This.bonding.type) {
          This.bondingError.bonding_type = "Please select a valid bonding type"
          errorCount +=1
        }else{
          This.bondingError.bonding_type = null
        }

        if(errorCount == 0 ){
          resolve(true)
        }else{
          reject(true)
        }

      })
    }
  },
  mounted(){
    this.getBondingTypes()
  },
};
</script>